import React from "react";
import { PostsPage } from "../components/PostsPage";

export default function News() {
  return (
    <PostsPage
      type="news"
      overline="Latest"
      title="News"
      subtitle="Updates and stories from the Te Manawa table tennis whānau."
      emptyText="No news yet — watch this space."
    />
  );
}
